export const getTestnetURI = (): string => {
    return "https://rpc-mumbai.maticvigil.com/";
};